import React from 'react';
import { Row, Col } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';

type Props = {
  label: string;
  info: string | JSX.Element;
};

export function DrawerInfoRow({ label, info }: Props) {
  return (
    <div className="drawer__info">
      <Row gutter={[0, 12]}>
        <Col span={8}>
          <label className="drawer__info-label">{label}</label>
        </Col>
        <Col span={16}>{info}</Col>
      </Row>
      <style jsx>{`
        .drawer__info {
          font-size: 16px;
        }

        .drawer__info-label {
          color: ${Colors.midnightLighter};
        }
      `}</style>
    </div>
  );
}
